import React, { useState, useEffect } from "react";

// Import images
import rt from "../assets/event1.jpg";
import ry from "../assets/event2.jpg";
import ru from "../assets/26.jpg";
import ri from "../assets/52.jpg";
import img2 from "../assets/agm.jpg";

// Import the new event images from the WhatsApp images
import congressEvent from "../assets/congress.jpeg";
import galaEvent from "../assets/gala.jpeg";

// Import PDF document
import pdfDocument from "../assets/doc/Mooki_Newsletter.pdf";

// International Nurses Day gallery images
import nd1 from "../assets/ind/in.jpeg";
import nd2 from "../assets/ind/inv.jpeg";
import nd3 from "../assets/ind/leb.jpeg";
import nd4 from "../assets/ind/horse.jpeg";
import nd5 from "../assets/ind/band.jpeg";
import nd6 from "../assets/ind/band1.jpeg";
import nd7 from "../assets/ind/band2.jpeg";
import nd8 from "../assets/ind/hom.jpeg";
import nd9 from "../assets/ind/band4.jpeg";
import nd0 from "../assets/ind/ba3.jpeg";
import nd11 from "../assets/ind/ba1.jpeg";
import nd31 from "../assets/ind/ba2.jpeg";
import nd12 from "../assets/ind/match3.jpeg";
import nd21 from "../assets/ind/match4.jpeg";
import nd32 from "../assets/ind/match5.jpeg";
import nd13 from "../assets/ind/nu2.jpeg";
import nd22 from "../assets/ind/nu3.jpeg";
import nd33 from "../assets/ind/q4.jpeg";
import nd14 from "../assets/ind/si1.jpeg";
import nd23 from "../assets/ind/si2.jpeg";
import nd34 from "../assets/ind/si3.jpeg";

const backgroundImages = [rt, ry, ru, ri];
const galleryImages = [nd1, nd2, nd3, nd4, nd5, nd6, nd7, nd8, nd9, nd0, nd11, nd12, nd31, nd21, nd32, nd13, nd22, nd33, nd14, nd23, nd34];

const newsUpdates = [
  {
    title: "International Nurses Day Celebrated in Mants'onyane",
    date: "May 12, 2025",
    description:
      "The International Nurses Day was joyfully celebrated in Mants'onyane on May 12, 2025. The event featured keynote speeches, community outreach, and cultural performances, highlighting the vital role nurses play in strengthening Lesotho's health system.",
    images: galleryImages,
  },
];

const upcomingEvents = [
  {
    event: "LENMO 49th Congress & Elective",
    date: "15 May 2026",
    time: "9:00 AM",
    location: "Ministry of Health Auditorium",
    theme: "The Power of Nurses",
    image: congressEvent,
    contact: "+26650060292",
    website: "www.lenmo.org.ls",
    type: "congress"
  },
  {
    event: "Members Engagement Gala Dinner",
    date: "15 May 2026",
    time: "18:00",
    location: "Victory Hall",
    theme: "Black Tie with a Touch of Gold",
    image: galaEvent,
    tickets: {
      standard: "M350",
      vip: "M450",
      table10: "M3000"
    },
    payment: {
      mpesa: "45799",
      ecocash: "35191"
    },
    paymentDeadline: "30 April 2026",
    type: "gala"
  },
];

const NewsLandingPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [analytics, setAnalytics] = useState({ views: 0, downloads: 0 });
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  
  // Newsletter subscription states
  const [email, setEmail] = useState("");
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    const storedAnalytics = localStorage.getItem('pdfAnalytics');
    if (storedAnalytics) {
      setAnalytics(JSON.parse(storedAnalytics));
    } else {
      const initialAnalytics = { views: 0, downloads: 0 };
      setAnalytics(initialAnalytics);
      localStorage.setItem('pdfAnalytics', JSON.stringify(initialAnalytics));
    }

    // Countdown timer for next event
    const targetDate = new Date('May 15, 2026 09:00:00').getTime();
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      
      if (distance > 0) {
        setCountdown({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);
    
    return () => {
      clearInterval(timer);
    };
  }, []);

  const trackView = () => {
    const updatedAnalytics = { ...analytics, views: analytics.views + 1 };
    setAnalytics(updatedAnalytics);
    localStorage.setItem('pdfAnalytics', JSON.stringify(updatedAnalytics));
  };

  const trackDownload = () => {
    const updatedAnalytics = { ...analytics, downloads: analytics.downloads + 1 };
    setAnalytics(updatedAnalytics);
    localStorage.setItem('pdfAnalytics', JSON.stringify(updatedAnalytics));
    showToastMessage("Download started successfully!");
  };

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const openGallery = (index) => {
    setSelectedImage(galleryImages[index]);
    setCurrentIndex(index);
  };

  const closeGallery = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setSelectedImage(galleryImages[nextIndex]);
    setCurrentIndex(nextIndex);
  };

  const prevImage = () => {
    const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setSelectedImage(galleryImages[prevIndex]);
    setCurrentIndex(prevIndex);
  };

  const openPdfModal = () => {
    setShowPdfModal(true);
    trackView();
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
  };

  const handleDownloadPdf = () => {
    trackDownload();
    const link = document.createElement('a');
    link.href = pdfDocument;
    link.download = 'Mooki_Newsletter.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleRegister = (eventName) => {
    showToastMessage(`Registration for ${eventName} opened! You'll receive a confirmation email.`);
  };

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    showToastMessage(`${type} copied to clipboard!`);
  };

  // Newsletter subscription handler
  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email) {
      showToastMessage("Please enter your email address");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showToastMessage("Please enter a valid email address");
      return;
    }

    setIsSubscribing(true);

    try {
      // Using PHP proxy for newsletter subscription
      const response = await fetch(
        "/proxy.php/backend/api/members/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSubscribed(true);
        setEmail("");
        showToastMessage("Successfully subscribed to our newsletter!");
        // Auto-hide success message after 5 seconds
        setTimeout(() => setSubscribed(false), 5000);
      } else {
        showToastMessage(data.message || "Subscription failed. You may already be subscribed.");
      }
    } catch (error) {
      console.error("Subscription Error:", error);
      showToastMessage("Failed to subscribe. Please try again later.");
    } finally {
      setIsSubscribing(false);
    }
  };

  return (
    <div className="news-container">
      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-background" style={{ backgroundImage: `url(${backgroundImages[0]})` }}>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-badge">Est. 1977</div>
          <h1 className="hero-title">
            Lesotho Nursing & <br />
            <span className="hero-highlight">Midwifery Organisation</span>
          </h1>
          <p className="hero-subtitle">
            Empowering Nurses. Advancing Healthcare. Transforming Lives.
          </p>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">5,000+</div>
              <div className="stat-label">Active Members</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Annual Events</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">20+</div>
              <div className="stat-label">Years of Excellence</div>
            </div>
          </div>
        </div>
      </section>

      {/* Countdown Section */}
      <div className="countdown-section">
        <div className="countdown-container">
          <p className="countdown-label">Countdown to LENMO Congress 2026</p>
          <div className="countdown-timer">
            <div className="countdown-item"><span>{countdown.days}</span><small>Days</small></div>
            <div className="countdown-separator">:</div>
            <div className="countdown-item"><span>{String(countdown.hours).padStart(2, '0')}</span><small>Hours</small></div>
            <div className="countdown-separator">:</div>
            <div className="countdown-item"><span>{String(countdown.minutes).padStart(2, '0')}</span><small>Minutes</small></div>
            <div className="countdown-separator">:</div>
            <div className="countdown-item"><span>{String(countdown.seconds).padStart(2, '0')}</span><small>Seconds</small></div>
          </div>
        </div>
      </div>

      {/* PDF Document Section */}
      <section id="resources" className="section">
        <div className="section-header">
          <span className="section-tag">Resources</span>
          <h2 className="section-title">Mooki Newsletter</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Stay updated with our latest publications and insights</p>
        </div>
        
        <div className="pdf-card">
          <div className="pdf-card-badge">Latest Issue</div>
          <div className="pdf-header">
            <div className="pdf-icon-wrapper">
              <svg className="pdf-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4H20V20H4V4Z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <path d="M8 7H16M8 11H14M8 15H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="pdf-info">
              <h3 className="pdf-title">Mooki Newsletter • Issue 3, Volume 2</h3>
              <p className="pdf-description">
                The Mooki Newsletter highlights key activities, milestones, and achievements of the Lesotho Nursing & Midwifery Organisation. It provides updates on programs, events, and initiatives aimed at strengthening nursing and midwifery practice across Lesotho.
              </p>
              <div className="pdf-meta">
                <span className="meta-badge">📄 PDF Document</span>
                <span className="meta-badge">📏 2.4 MB</span>
                <span className="meta-badge">📖 24 Pages</span>
                <span className="meta-badge">📅 January 2026</span>
              </div>
            </div>
          </div>
          
          <div className="pdf-analytics">
            <div className="analytics-card">
              <div className="analytics-icon">👁️</div>
              <div className="analytics-stats">
                <div className="analytics-number">{analytics.views}</div>
                <div className="analytics-label">Total Views</div>
              </div>
            </div>
            <div className="analytics-card">
              <div className="analytics-icon">⬇️</div>
              <div className="analytics-stats">
                <div className="analytics-number">{analytics.downloads}</div>
                <div className="analytics-label">Downloads</div>
              </div>
            </div>
          </div>
          
          <div className="pdf-actions">
            <button className="btn-primary" onClick={openPdfModal}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              Preview Newsletter
            </button>
            <button className="btn-secondary" onClick={handleDownloadPdf}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Download PDF
            </button>
          </div>
        </div>
      </section>

      {/* Latest News Section */}
      <section id="news" className="section news-section">
        <div className="section-header">
          <span className="section-tag">Latest Updates</span>
          <h2 className="section-title">News & Stories</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Discover the latest happenings in the nursing community</p>
        </div>
        
        {newsUpdates.map((news, index) => (
          <article key={index} className="news-card">
            <div className="news-card-header">
              <div className="news-badge">Feature Story</div>
              <div className="news-date">
                <span className="date-day">{new Date(news.date).getDate()}</span>
                <span className="date-month">{new Date(news.date).toLocaleString('default', { month: 'short' })}</span>
              </div>
            </div>
            <h3 className="news-title">{news.title}</h3>
            <p className="news-description">{news.description}</p>
            <div className="news-footer">
              <button className="read-more-btn">
                Read Full Story
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
            
            {/* Gallery Section */}
            <div className="gallery-section">
              <div className="gallery-header">
                <h4 className="gallery-title">Event Highlights</h4>
                <span className="gallery-count">{news.images.length} Photos</span>
              </div>
              <div className="gallery-grid">
                {news.images.slice(0, 8).map((image, idx) => (
                  <div 
                    key={idx} 
                    className="gallery-item"
                    onClick={() => openGallery(idx)}
                  >
                    <img src={image} alt={`Gallery ${idx + 1}`} className="gallery-image" loading="lazy" />
                    <div className="image-overlay">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
              {news.images.length > 8 && (
                <button className="view-all-btn">View All {news.images.length} Photos →</button>
              )}
            </div>
          </article>
        ))}
      </section>

      {/* Upcoming Events Section */}
      <section id="events" className="section events-section">
        <div className="section-header">
          <span className="section-tag">Join Us</span>
          <h2 className="section-title">Upcoming Events</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">Be part of our transformative events and celebrations</p>
        </div>
        
        <div className="events-grid">
          {upcomingEvents.map((event, index) => (
            <div key={index} className="event-card">
              <div className="event-badge">{event.type === 'congress' ? 'Congress' : 'Gala Dinner'}</div>
              <div className="event-image-wrapper">
                <img src={event.image} alt={event.event} className="event-image" />
                <div className="event-date-badge">
                  <span className="event-date-day">{event.date.split(' ')[0]}</span>
                  <span className="event-date-month">{event.date.split(' ')[1]}</span>
                </div>
              </div>
              <div className="event-content">
                <h3 className="event-title">{event.event}</h3>
                <div className="event-details">
                  <div className="event-detail">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>{event.date} • {event.time}</span>
                  </div>
                  <div className="event-detail">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{event.location}</span>
                  </div>
                  <div className="event-detail">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20.59 13.41l-2.83 2.83a4 4 0 0 1-5.66 0L9.17 13.4a4 4 0 0 1 0-5.66l2.83-2.83"></path>
                      <path d="M8.5 10.5L6 13"></path>
                    </svg>
                    <span>Theme: {event.theme}</span>
                  </div>
                  {event.tickets && (
                    <>
                      <div className="event-detail tickets-info">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M15 5v2M15 11v2M15 17v2M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 1 2-2z"></path>
                        </svg>
                        <div className="ticket-prices">
                          <span className="ticket-standard">Standard: {event.tickets.standard}</span>
                          <span className="ticket-vip">VIP: {event.tickets.vip}</span>
                          <span className="ticket-table">Table of 10: {event.tickets.table10}</span>
                        </div>
                      </div>
                      <div className="event-detail payment-info">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M12 2v20M2 12h20"></path>
                        </svg>
                        <div className="payment-methods">
                          <span className="payment-mpesa" onClick={() => copyToClipboard(event.payment.mpesa, 'M-Pesa Code')}>M-Pesa: {event.payment.mpesa}</span>
                          <span className="payment-ecocash" onClick={() => copyToClipboard(event.payment.ecocash, 'EcoCash Code')}>EcoCash: {event.payment.ecocash}</span>
                        </div>
                      </div>
                      <div className="event-detail deadline">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        <span>Payment Deadline: {event.paymentDeadline}</span>
                      </div>
                    </>
                  )}
                  {event.contact && (
                    <div className="event-detail contact-info" onClick={() => copyToClipboard(event.contact, 'Contact number')}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                      <span>{event.contact}</span>
                    </div>
                  )}
                  {event.website && (
                    <div className="event-detail">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                      </svg>
                      <a href={`https://${event.website}`} target="_blank" rel="noopener noreferrer">{event.website}</a>
                    </div>
                  )}
                </div>
                <button className="event-register-btn" onClick={() => handleRegister(event.event)}>
                  Register Now
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Newsletter Section - Updated with subscription functionality */}
      <div className="newsletter-section">
        <div className="newsletter-container">
          <div className="newsletter-content">
            <h3 className="newsletter-title">Stay Connected</h3>
            <p className="newsletter-text">Subscribe to our newsletter for updates on events, publications, and nursing news.</p>
            
            {subscribed ? (
              <div className="subscription-success">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <p>Thank you for subscribing! You'll receive our latest updates.</p>
              </div>
            ) : (
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <input 
                  type="email" 
                  placeholder="Enter your email address" 
                  className="newsletter-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubscribing}
                  required
                />
                <button 
                  type="submit" 
                  className="newsletter-btn"
                  disabled={isSubscribing}
                >
                  {isSubscribing ? (
                    <>
                      <span className="spinner"></span>
                      Subscribing...
                    </>
                  ) : (
                    'Subscribe'
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-icon">🏥</span>
              <span>LENMO</span>
            </div>
            <p className="footer-description">Empowering nurses and midwives across Lesotho to deliver exceptional healthcare services.</p>
            <div className="social-links">
              <a href="#" className="social-link">📘</a>
              <a href="#" className="social-link">🐦</a>
              <a href="#" className="social-link">📸</a>
              <a href="#" className="social-link">💼</a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#news">News</a></li>
              <li><a href="#events">Events</a></li>
              <li><a href="#resources">Resources</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li>📞 +266 5006 0292</li>
              <li>✉️ info@lenmo.org.ls</li>
              <li>🌐 www.lenmo.org.ls</li>
              <li>📍 Maseru, Lesotho</li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Office Hours</h4>
            <ul>
              <li>Monday - Friday: 8:00 - 17:00</li>
              <li>Saturday: Closed</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Lesotho Nursing & Midwifery Organisation. All rights reserved.</p>
        </div>
      </footer>

      {/* Gallery Modal */}
      {selectedImage && (
        <div className="gallery-modal" onClick={closeGallery}>
          <button className="modal-close" onClick={closeGallery}>×</button>
          <button className="modal-nav modal-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>‹</button>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Gallery" className="modal-image" />
            <div className="modal-counter">{currentIndex + 1} / {galleryImages.length}</div>
          </div>
          <button className="modal-nav modal-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>›</button>
        </div>
      )}

      {/* PDF Modal */}
      {showPdfModal && (
        <div className="pdf-modal-overlay" onClick={closePdfModal}>
          <div className="pdf-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal-header">
              <h3>Mooki Newsletter • Issue 3, Volume 2</h3>
              <button className="pdf-modal-close" onClick={closePdfModal}>×</button>
            </div>
            <div className="pdf-modal-content">
              <iframe src={`${pdfDocument}#view=FitH`} title="Mooki Newsletter" className="pdf-iframe" />
            </div>
            <div className="pdf-modal-footer">
              <button className="pdf-modal-btn" onClick={handleDownloadPdf}>Download PDF</button>
              <div className="pdf-modal-analytics">
                <span>👁️ {analytics.views} views</span>
                <span>⬇️ {analytics.downloads} downloads</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {showToast && (
        <div className="toast-notification">
          {toastMessage}
        </div>
      )}
    </div>
  );
};

// Inject Styles with additional newsletter subscription styles
const styles = document.createElement("style");
styles.textContent = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
    color: #1e293b;
  }

  /* Hero Section */
  .hero-section {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .hero-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
  }

  .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.7));
  }

  .hero-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: white;
    max-width: 800px;
    padding: 0 2rem;
  }

  .hero-badge {
    display: inline-block;
    background: rgba(59, 130, 246, 0.2);
    backdrop-filter: blur(10px);
    padding: 0.5rem 1rem;
    border-radius: 50px;
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .hero-title {
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    font-weight: 800;
    margin-bottom: 1rem;
    line-height: 1.2;
  }

  .hero-highlight {
    background: linear-gradient(135deg, #3b82f6, #60a5fa);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .hero-subtitle {
    font-size: 1.2rem;
    color: #e2e8f0;
    margin-bottom: 2rem;
  }

  .hero-stats {
    display: flex;
    justify-content: center;
    gap: 3rem;
    margin-top: 3rem;
    flex-wrap: wrap;
  }

  .stat-item {
    text-align: center;
  }

  .stat-number {
    font-size: 2rem;
    font-weight: 700;
    color: #3b82f6;
  }

  .stat-label {
    font-size: 0.9rem;
    color: #cbd5e1;
  }

  /* Countdown */
  .countdown-section {
    background: linear-gradient(135deg, #1e3a8a, #3b82f6);
    padding: 2rem;
    text-align: center;
  }

  .countdown-container {
    max-width: 1280px;
    margin: 0 auto;
  }

  .countdown-label {
    color: white;
    font-size: 1.1rem;
    margin-bottom: 1rem;
    opacity: 0.9;
  }

  .countdown-timer {
    display: flex;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .countdown-item {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    padding: 1rem;
    border-radius: 12px;
    min-width: 80px;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .countdown-item span {
    font-size: 2.5rem;
    font-weight: 800;
  }

  .countdown-item small {
    font-size: 0.8rem;
    opacity: 0.8;
  }

  .countdown-separator {
    font-size: 2.5rem;
    color: white;
    display: flex;
    align-items: center;
  }

  /* Sections */
  .section {
    padding: 5rem 2rem;
    max-width: 1280px;
    margin: 0 auto;
  }

  .section-header {
    text-align: center;
    margin-bottom: 3rem;
  }

  .section-tag {
    display: inline-block;
    background: linear-gradient(135deg, #3b82f6, #60a5fa);
    padding: 0.3rem 1rem;
    border-radius: 50px;
    color: white;
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .section-title {
    font-size: clamp(2rem, 4vw, 2.8rem);
    font-weight: 800;
    color: #1e293b;
    margin-bottom: 1rem;
  }

  .section-divider {
    width: 80px;
    height: 3px;
    background: linear-gradient(90deg, #3b82f6, #60a5fa);
    margin: 1rem auto;
    border-radius: 3px;
  }

  .section-subtitle {
    color: #64748b;
    font-size: 1.1rem;
  }

  /* PDF Card */
  .pdf-card {
    background: white;
    border-radius: 24px;
    padding: 2rem;
    box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.1);
    position: relative;
    transition: all 0.3s ease;
  }

  .pdf-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 25px 45px -12px rgba(0, 0, 0, 0.15);
  }

  .pdf-card-badge {
    position: absolute;
    top: -12px;
    right: 2rem;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    padding: 0.3rem 1rem;
    border-radius: 50px;
    font-size: 0.8rem;
    font-weight: 600;
  }

  .pdf-header {
    display: flex;
    gap: 1.5rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
  }

  .pdf-icon-wrapper {
    flex-shrink: 0;
    width: 70px;
    height: 70px;
    background: linear-gradient(135deg, #fee2e2, #fecaca);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pdf-icon-svg {
    width: 40px;
    height: 40px;
    color: #dc2626;
  }

  .pdf-info {
    flex: 1;
  }

  .pdf-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
  }

  .pdf-description {
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  .pdf-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .meta-badge {
    background: #f1f5f9;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.85rem;
    color: #475569;
  }

  .pdf-analytics {
    display: flex;
    gap: 1.5rem;
    margin-bottom: 2rem;
    padding: 1rem 0;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
    flex-wrap: wrap;
  }

  .analytics-card {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .analytics-icon {
    font-size: 2rem;
  }

  .analytics-stats {
    display: flex;
    flex-direction: column;
  }

  .analytics-number {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
  }

  .analytics-label {
    font-size: 0.8rem;
    color: #64748b;
  }

  .pdf-actions {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .btn-primary, .btn-secondary {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.9rem 1.5rem;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .btn-primary {
    background: linear-gradient(135deg, #3b82f6, #1e3a8a);
    color: white;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(59, 130, 246, 0.4);
  }

  .btn-secondary {
    background: #f1f5f9;
    color: #1e293b;
  }

  .btn-secondary:hover {
    background: #e2e8f0;
    transform: translateY(-2px);
  }

  /* News Section */
  .news-section {
    background: #f8fafc;
  }

  .news-card {
    background: white;
    border-radius: 24px;
    padding: 2rem;
    margin-bottom: 2rem;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
  }

  .news-card:hover {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }

  .news-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .news-badge {
    background: linear-gradient(135deg, #3b82f6, #60a5fa);
    color: white;
    padding: 0.3rem 0.8rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
  }

  .news-date {
    text-align: center;
    background: #f1f5f9;
    padding: 0.5rem;
    border-radius: 12px;
    min-width: 60px;
  }

  .date-day {
    display: block;
    font-size: 1.3rem;
    font-weight: 700;
    color: #1e293b;
  }

  .date-month {
    display: block;
    font-size: 0.7rem;
    color: #64748b;
  }

  .news-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1rem;
  }

  .news-description {
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  .read-more-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: none;
    border: none;
    color: #3b82f6;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .read-more-btn:hover {
    gap: 0.8rem;
  }

  /* Gallery */
  .gallery-section {
    margin-top: 2rem;
  }

  .gallery-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    flex-wrap: wrap;
  }

  .gallery-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #1e293b;
  }

  .gallery-count {
    color: #64748b;
    font-size: 0.9rem;
  }

  .gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
  }

  .gallery-item {
    position: relative;
    aspect-ratio: 1;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .gallery-item:hover .gallery-image {
    transform: scale(1.1);
  }

  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .gallery-item:hover .image-overlay {
    opacity: 1;
  }

  .view-all-btn {
    margin-top: 1rem;
    background: none;
    border: none;
    color: #3b82f6;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .view-all-btn:hover {
    color: #1e3a8a;
  }

  /* Events Section */
  .events-section {
    background: white;
  }

  .events-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
    gap: 2rem;
  }

  .event-card {
    background: white;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;
  }

  .event-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  }

  .event-badge {
    position: absolute;
    top: 1rem;
    left: 1rem;
    z-index: 2;
    background: linear-gradient(135deg, #3b82f6, #1e3a8a);
    color: white;
    padding: 0.3rem 1rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
  }

  .event-image-wrapper {
    position: relative;
    height: 220px;
    overflow: hidden;
  }

  .event-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .event-card:hover .event-image {
    transform: scale(1.05);
  }

  .event-date-badge {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    background: white;
    padding: 0.5rem;
    border-radius: 12px;
    text-align: center;
    min-width: 55px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .event-date-day {
    display: block;
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
  }

  .event-date-month {
    display: block;
    font-size: 0.7rem;
    color: #64748b;
  }

  .event-content {
    padding: 1.5rem;
  }

  .event-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1rem;
  }

  .event-details {
    margin-bottom: 1.5rem;
  }

  .event-detail {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
    color: #64748b;
    font-size: 0.9rem;
    flex-wrap: wrap;
  }

  .tickets-info {
    flex-direction: column;
    align-items: flex-start;
  }

  .ticket-prices {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-left: 1.75rem;
  }

  .ticket-standard, .ticket-vip, .ticket-table {
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    font-size: 0.8rem;
  }

  .ticket-standard {
    background: #e0f2fe;
    color: #0369a1;
  }

  .ticket-vip {
    background: #fef3c7;
    color: #b45309;
  }

  .ticket-table {
    background: #dcfce7;
    color: #15803d;
  }

  .payment-info {
    background: #f8fafc;
    padding: 0.75rem;
    border-radius: 12px;
    margin: 0.5rem 0;
  }

  .payment-methods {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-left: 1.75rem;
  }

  .payment-mpesa, .payment-ecocash {
    cursor: pointer;
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .payment-mpesa {
    background: #fee2e2;
    color: #dc2626;
  }

  .payment-ecocash {
    background: #e0e7ff;
    color: #4338ca;
  }

  .payment-mpesa:hover, .payment-ecocash:hover {
    transform: scale(1.05);
  }

  .deadline {
    background: #fffbeb;
    border-left: 3px solid #f59e0b;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    color: #92400e;
  }

  .contact-info {
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .contact-info:hover {
    color: #3b82f6;
  }

  .event-register-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: linear-gradient(135deg, #3b82f6, #1e3a8a);
    color: white;
    border: none;
    padding: 0.8rem;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .event-register-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(59, 130, 246, 0.4);
  }

  /* Newsletter Section */
  .newsletter-section {
    background: linear-gradient(135deg, #1e3a8a, #3b82f6);
    padding: 4rem 2rem;
  }

  .newsletter-container {
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
  }

  .newsletter-title {
    font-size: 2rem;
    color: white;
    margin-bottom: 1rem;
  }

  .newsletter-text {
    color: #e2e8f0;
    margin-bottom: 2rem;
  }

  .newsletter-form {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .newsletter-input {
    flex: 1;
    padding: 0.8rem 1rem;
    border: none;
    border-radius: 50px;
    font-size: 1rem;
    outline: none;
  }

  .newsletter-btn {
    background: #f59e0b;
    color: white;
    border: none;
    padding: 0.8rem 2rem;
    border-radius: 50px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .newsletter-btn:hover:not(:disabled) {
    background: #d97706;
    transform: translateY(-2px);
  }

  .newsletter-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .newsletter-input:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  /* Subscription Success Styles */
  .subscription-success {
    text-align: center;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    backdrop-filter: blur(10px);
    animation: fadeInUp 0.5s ease;
  }

  .subscription-success svg {
    margin-bottom: 1rem;
    animation: checkmark 0.5s ease;
  }

  .subscription-success p {
    color: white;
    font-size: 1rem;
  }

  /* Spinner Animation */
  .spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes checkmark {
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* Footer */
  .footer {
    background: #0f172a;
    color: #e2e8f0;
    padding: 3rem 2rem 1rem;
  }

  .footer-content {
    max-width: 1280px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
  }

  .footer-logo {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .logo-icon {
    font-size: 1.8rem;
  }

  .footer-description {
    color: #94a3b8;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  .social-links {
    display: flex;
    gap: 1rem;
  }

  .social-link {
    display: inline-block;
    padding: 0.5rem;
    background: #1e293b;
    border-radius: 50%;
    text-decoration: none;
    font-size: 1.2rem;
    transition: all 0.3s ease;
  }

  .social-link:hover {
    background: #3b82f6;
    transform: translateY(-2px);
  }

  .footer-section h4 {
    margin-bottom: 1rem;
    color: white;
  }

  .footer-section ul {
    list-style: none;
  }

  .footer-section li {
    margin-bottom: 0.5rem;
    color: #94a3b8;
  }

  .footer-section a {
    color: #94a3b8;
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .footer-section a:hover {
    color: #3b82f6;
  }

  .footer-bottom {
    text-align: center;
    padding-top: 2rem;
    border-top: 1px solid #1e293b;
    color: #64748b;
    font-size: 0.9rem;
  }

  /* Modal Styles */
  .gallery-modal, .pdf-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }

  .modal-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    color: white;
    font-size: 3rem;
    cursor: pointer;
    z-index: 2001;
  }

  .modal-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    font-size: 3rem;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .modal-prev { left: 2rem; }
  .modal-next { right: 2rem; }

  .modal-nav:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  .modal-image {
    max-width: 90vw;
    max-height: 80vh;
    object-fit: contain;
  }

  .modal-counter {
    color: white;
    text-align: center;
    margin-top: 1rem;
  }

  .pdf-modal {
    background: white;
    border-radius: 20px;
    width: 90%;
    height: 90%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .pdf-modal-header {
    padding: 1rem 1.5rem;
    background: #1e293b;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pdf-modal-close {
    background: none;
    border: none;
    color: white;
    font-size: 1.8rem;
    cursor: pointer;
  }

  .pdf-modal-content {
    flex: 1;
    overflow: auto;
  }

  .pdf-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .pdf-modal-footer {
    padding: 1rem 1.5rem;
    background: #f8fafc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e2e8f0;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .pdf-modal-btn {
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    border: none;
    padding: 0.6rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
  }

  .pdf-modal-analytics {
    display: flex;
    gap: 1rem;
  }

  /* Toast Notification */
  .toast-notification {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    background: #1e293b;
    color: white;
    padding: 0.8rem 1.5rem;
    border-radius: 50px;
    z-index: 2000;
    animation: slideIn 0.3s ease;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  /* Responsive */
  @media (max-width: 768px) {
    .hero-stats {
      flex-direction: column;
      gap: 1rem;
    }
    
    .pdf-header {
      flex-direction: column;
      text-align: center;
    }
    
    .pdf-icon-wrapper {
      align-self: center;
    }
    
    .pdf-analytics {
      flex-direction: column;
      align-items: center;
    }
    
    .pdf-actions {
      flex-direction: column;
    }
    
    .events-grid {
      grid-template-columns: 1fr;
    }
    
    .gallery-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .newsletter-form {
      flex-direction: column;
    }
    
    .newsletter-btn {
      width: 100%;
      justify-content: center;
    }
    
    .countdown-timer {
      gap: 0.5rem;
    }
    
    .countdown-item {
      min-width: 70px;
      padding: 0.6rem;
    }
    
    .countdown-item span {
      font-size: 1.5rem;
    }
    
    .countdown-separator {
      font-size: 1.5rem;
    }
    
    .footer-content {
      grid-template-columns: 1fr;
      text-align: center;
    }
    
    .footer-logo {
      justify-content: center;
    }
    
    .social-links {
      justify-content: center;
    }
    
    .modal-nav {
      width: 40px;
      height: 40px;
      font-size: 2rem;
    }
    
    .modal-prev { left: 0.5rem; }
    .modal-next { right: 0.5rem; }
  }
`;
document.head.appendChild(styles);

export default NewsLandingPage;